import { render, staticRenderFns } from "./DetailOne.vue?vue&type=template&id=58bbddcf&"
import script from "./DetailOne.vue?vue&type=script&lang=js&"
export * from "./DetailOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58bbddcf')) {
      api.createRecord('58bbddcf', component.options)
    } else {
      api.reload('58bbddcf', component.options)
    }
    module.hot.accept("./DetailOne.vue?vue&type=template&id=58bbddcf&", function () {
      api.rerender('58bbddcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/details/DetailOne.vue"
export default component.exports